import { createFileRoute } from "@tanstack/react-router";
import { FormsFullPage } from "@/components/pages/FormsFullPage";

export const Route = createFileRoute("/forms-full")({
  head: () => ({
    meta: [
      { title: "Diagnóstico de atendimento — Kentro em chat" },
      {
        name: "description",
        content:
          "Responda algumas perguntas em um chat rápido e nossa equipe entra em contato pelo WhatsApp com um diagnóstico do seu atendimento.",
      },
      { property: "og:title", content: "Diagnóstico de atendimento — Kentro em chat" },
      {
        property: "og:description",
        content:
          "Formulário conversacional completo da Kentro: perfil da empresa, volume de mensagens, desafios e prazo de implantação.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: FormsFullPage,
});
